import SocketIOClient from 'socket.io-client'

import { SOCKET_URL } from '_config/environment'
import { UPDATE_PROFILE } from '_modules/user/actions'
import { GET_COLLABORATORS } from '_modules/collaboration/actions'
import { UPDATE_SETTINGS } from '_modules/settings/actions'

import { USER_STATUS_TYPES } from '_utils/userStatusType'

import { store } from '../setupApp'

let socket = null

export default class Socket {
  static connect() {
    socket = SocketIOClient(SOCKET_URL)
    socket.on('connect', () => {
      const { user } = store.getState()
      socket.emit('joinRoom', user.get('id'))

      socket.on('userStatusChanged', data => {
        const { userId, status } = data
        if (userId === user.get('id')) {
          store.dispatch({
            type: UPDATE_PROFILE.PENDING,
          })
          store.dispatch({
            type: UPDATE_PROFILE.FULFILLED,
            payload: { status },
          })
        } else {
          const { collab } = store.getState()
          const collaborators = collab.get('collaborators').toArray()

          // check if collaborators populated yet
          if (collaborators.length > 0) {
            const invitation = collaborators.find(c => c.collaborator._id === userId)
            if (!!invitation) {
              invitation.collaborator.status = status

              const payload = collab.get('collaborators').toJS()
              payload[invitation._id] = invitation
              store.dispatch({
                type: GET_COLLABORATORS.PENDING,
              })
              store.dispatch({
                type: GET_COLLABORATORS.FULFILLED,
                payload,
              })
            }
          }
        }
      })

      socket.on('queueCountChanged', queueCount => {
        store.dispatch({
          type: 'SET_QUEUE_COUNT',
          payload: queueCount,
        })
      })

      socket.on('currentTaskChanged', currentTask => {
        // set current task
        store.dispatch({
          type: 'SET_CURRENT_TASK',
          payload: currentTask,
        })
        if (store.getState().settings.get('autoStatus') && currentTask.logEntry) {
          socket.emit('changeUserStatus', USER_STATUS_TYPES.FOCUSED)
        }

        // clear counter if current task changing to none
        if (currentTask.startedAt === store.getState().currentTask.get('startedAt')) {
          const counterId = store.getState().counter.get('intervalId')
          if (counterId) clearInterval(counterId)
          store.dispatch({
            type: 'RESET_COUNTER_REDUX',
          })
        }
      })

      socket.on('settingsChanged', settings => {
        store.dispatch({
          type: UPDATE_SETTINGS.PENDING,
        })
        store.dispatch({
          type: UPDATE_SETTINGS.FULFILLED,
          payload: settings,
        })
      })

      socket.on('lastActivityChanged', updatedUser => {
        store.dispatch({
          type: UPDATE_PROFILE.PENDING,
        })
        store.dispatch({
          type: UPDATE_PROFILE.FULFILLED,
          payload: updatedUser,
        })
      })
    })
  }

  static emit(event, data) {
    socket.emit(event, data)
  }
}



// WEBPACK FOOTER //
// ./src/utils/socket.js